export const AlertBannerContent =
  "Require assistance with your subscription? Write us at info@trovecode.com to inquire or make a purchase.";
